import script from "./AlertsFeedRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsFeedRow.vue?vue&type=script&setup=true&lang=js"

import "./AlertsFeedRow.vue?vue&type=style&index=0&id=42225fc0&lang=scss"

const __exports__ = script;

export default __exports__